import Vue from 'vue'
import Router from 'vue-router'
import AppHeader from './layout/AppHeader'
import AppFooter from './layout/AppFooter'
import Datenschutz from './views/Datenschutz.vue'
import Landing from './views/Landing.vue'
import Impressum from './views/Impressum.vue'
import WordPress from './views/WordPress.vue'
import ECommerce from './views/ECommerce.vue'
import FullStack from './views/FullStack.vue'
import PageSpeed from './views/PageSpeed.vue'
import Barrierefreiheit from './views/Barrierefreiheit.vue'
import Refactoring from './views/Refactoring.vue'
import KISoftwareentwicklung from './views/KISoftwareentwicklung.vue'

Vue.use(Router)

export default new Router({
    linkExactActiveClass: 'active',
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            components: {
                header: AppHeader,
                default: Landing,
                footer: AppFooter,
            },
        },
        {
            path: '/datenschutz',
            name: 'datenschutz',
            components: {
                header: AppHeader,
                default: Datenschutz,
                footer: AppFooter,
            },
        },
        {
            path: '/impressum',
            name: 'impressum',
            components: {
                header: AppHeader,
                default: Impressum,
                footer: AppFooter,
            },
        },
        {
            path: '/wordpress',
            name: 'wordpress',
            components: {
                header: AppHeader,
                default: WordPress,
                footer: AppFooter,
            },
        },
        {
            path: '/ecommerce',
            name: 'ecommerce',
            components: {
                header: AppHeader,
                default: ECommerce,
                footer: AppFooter,
            },
        },
        {
            path: '/full-stack',
            name: 'fullstack',
            components: {
                header: AppHeader,
                default: FullStack,
                footer: AppFooter,
            },
        },
        {
            path: '/page-speed-optimierung',
            name: 'pagespeed',
            components: {
                header: AppHeader,
                default: PageSpeed,
                footer: AppFooter,
            },
        },
        {
            path: '/barrierefreiheit',
            name: 'barrierefreiheit',
            components: {
                header: AppHeader,
                default: Barrierefreiheit,
                footer: AppFooter,
            },
        },
        {
            path: '/refactoring',
            name: 'refactoring',
            components: {
                header: AppHeader,
                default: Refactoring,
                footer: AppFooter,
            },
        },
        {
            path: '/ki-softwareentwicklung',
            name: 'ki-softwareentwicklung',
            components: {
                header: AppHeader,
                default: KISoftwareentwicklung,
                footer: AppFooter,
            },
        },
    ],
    scrollBehavior: (to) => {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    },
})
